// Full-document render of the password-reset complete view: PageSkeleton (the
// React document shell) wrapping the toppers account-shell layout (side nav +
// content title) around the confirmation copy + log-in button. The button
// carries toppers' `button--ming` modifier (the template's class). All
// copy arrives pre-localized as props (server-side gettext).
import React from "react";

import { templates } from "@reactivated";

import { AccountShell } from "../components/AccountShell";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.PasswordResetCompleteDocumentTemplate,
): React.JSX.Element => (
    <PageSkeleton pageChrome={props.page_chrome}>
        <AccountShell
            hasNav={props.has_nav}
            sideNav={props.side_nav}
            title={props.content_title}
            phoneDisplay={props.phone_display}
            phoneHref={props.phone_href}
        >
            {props.complete_text}
            <p>{props.body_text}</p>
            <p>
                <a href={props.login_url} className="button button--ming">
                    {props.login_label}
                </a>
            </p>
        </AccountShell>
    </PageSkeleton>
);
